import { customColors } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

/** Just a normal react-router-dom NavLink with styles applied */
export const StyledMenuNavLink = React.forwardRef<
  HTMLAnchorElement,
  NavLinkProps
>(({ className, activeStyle, ...props }, ref) => {
  return (
    <NavLink
      {...props}
      ref={ref}
      className={classnames(
        'flex break-all rounded border border-transparent px-3 py-2 pl-3.5 text-base text-neutral transition duration-150 hover:bg-neutral',
        className,
      )}
      activeClassName="font-semibold"
      // can't override tailwind classes with tailwind classes because they have the same specificity
      activeStyle={{
        paddingLeft: 12,
        borderColor: 'transparent',
        borderLeftWidth: 3,
        borderLeftColor: customColors.border.info,
        background: customColors.btn['secondary-selected'],
        color: customColors.text.primary,
        ...activeStyle,
      }}
    />
  );
});
